<template>
  <div v-if="hint" class="mt-2">
    <span :class="{ 'text-bittersweet-600': isError }">{{ hint }}</span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  hint?: string;
  isError?: boolean;
}>();
</script>
